import { createGlobalStyle } from 'styled-components';

/**
 * Global styles for the hosted standalone page.
 * No fixed height — the HostedPageWrapper controls layout.
 */
export const HostedGlobalStyles = createGlobalStyle`
  html,
  body {
    margin: 0;
    padding: 0;
    height: 100%;
  }

  * {
    box-sizing: border-box;
    font-family: Helvetica, Arial, sans-serif;
    font-weight: 300;
  }

  a {
    transition-duration: ${({ theme }) => theme.transitionDuration};
  }
`;

/**
 * Global styles for the embeddable widget (iframe / client-site div).
 * Retains the fixed 425px height for backwards compatibility.
 */
export const EmbedGlobalStyles = createGlobalStyle`
  html,
  body {
    margin: 0;
    padding: 0;
    height: 425px;
  }

  * {
    box-sizing: border-box;
    font-family: Helvetica, Arial, sans-serif;
    font-weight: 300;
  }

  a {
    transition-duration: ${({ theme }) => theme.transitionDuration};
  }
`;
